import auth from '@/modules/authentication/auth'

function requireAuth(to, from, next) {
	auth.isLoggedIn()
		.then(result => {
			if (result) {
				next();
			} else {
				auth.setLoginRedirect(to.fullPath);
				next({
					path: '/login',
				});
			}
		})
	;
}

function prohibitAuth(to, from, next) {
	auth.isLoggedIn()
		.then(result => {
			if (result) {
				next({
					path: auth.getLoginRedirect() || '/',
				});
			} else {
				next();
			}
		})
	;
}

export {
	requireAuth,
	prohibitAuth,
}
